"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultTitle = exports.IMAGE_TYPES = void 0;

var _dateFns = require("date-fns");

const IMAGE_TYPES = {
  NORMAL: "normal",
  VIDEO: "video",
  PHOTOSPHERE: "photosphere"
};
exports.IMAGE_TYPES = IMAGE_TYPES;
const TYPE_MAP = {
  [IMAGE_TYPES.NORMAL]: "photo",
  [IMAGE_TYPES.VIDEO]: "video",
  [IMAGE_TYPES.PHOTOSPHERE]: "360photo"
};

const getDefaultTitle = media => {
  return media && (0, _dateFns.format)(new Date(media.takenOn || media.createdAt), "yyyyLLdd_KKkkmmss") + `_${media.imageType && TYPE_MAP[media.imageType]}`;
};

exports.getDefaultTitle = getDefaultTitle;